import academyService from '@/services/academy.js';
import _ from 'lodash';

const state = {
  subAcademies: null,
  classes: null,
  studentsByClassMapping: null,
  showManagementCaptionType: null,
  showManagementCaptionStudent: null,
};

const getters = {
  subAcademies(state) {
    return state.subAcademies;
  },
  classes(state) {
    return state.classes;
  },
  studentsByClass(state) {
    return state.studentsByClass;
  },
};

const actions = {
  async getClasses({commit}) {
    const res = await academyService.getClasses();
    const subAcademies = res.map((clazz) => {
      return {
        subAcademyId: clazz.subAcademyId,
        subAcademyName: clazz.subAcademyName,
      };
    });

    commit('setSubAcademies', _.uniqBy(subAcademies, 'subAcademyId'));
    commit('setClasses', res);
  },
  async getStudentsByClass({commit, state}, {classId, limit}) {
    const studentsByClassMapping = state.studentsByClassMapping || {};
    const originStudents = studentsByClassMapping[classId] || [];
    const lastUsername = originStudents[originStudents.length - 1]?.username;
    const students = await academyService.getStudentsByClass({
      classId,
      lastUsername,
      limit,
    });
    originStudents.push(
      ...students.map((student) => {
        return {
          ...student,
          classId,
        };
      })
    );
    studentsByClassMapping[classId] = originStudents;
    commit('setStudentsByClassMapping', studentsByClassMapping);
    return students;
  },
};

const mutations = {
  setSubAcademies(state, value) {
    state.subAcademies = _.sortBy(value, 'subAcademyName');
  },
  setClasses(state, value) {
    state.classes = _.sortBy(value, 'className');
  },
  setStudentsByClassMapping(state, value) {
    state.studentsByClassMapping = value;
  },
  clearStudentData(state) {
    state.subAcademies = null;
    state.classes = null;
    state.studentsByClassMapping = null;
    state.showManagementCaptionType = null;
    state.showManagementCaptionStudent = null;
  },
  setShowManagementCaptionType(state, {type, student}) {
    state.showManagementCaptionType = type;
    state.showManagementCaptionStudent = student;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
